export interface ActionDefaults {
  timeToStart?: number;
  stayUntilParentApproves?: boolean;
  stayUntilChecked?: boolean;
  stayUntilFixedTime?: boolean;
  duration?: number;
}

export const SEND_ACTION_DEFAULTS: Required<ActionDefaults> = {
  timeToStart: 5,
  stayUntilParentApproves: false,
  stayUntilChecked: false,
  stayUntilFixedTime: true,
  duration: 30,
};

export interface Action {
  id: string;
  name: string;
  description: string;
  pictureUrl: string | null;
  thumbnailUrl: string | null;
  soundUrl: string | null;
  defaults?: ActionDefaults | null;
  createdAt: number;  // Unix timestamp in milliseconds
  updatedAt: number;
  updatedBy: string;  // Firebase Auth UID
}

export interface SignedUrlResponse {
  url: string;
  expires_in: number;
  type: 'original' | 'thumbnail';
}

export interface SignedUrlInfo {
  url: string;
  type: 'original' | 'thumbnail';
}

export interface BatchSignedUrlsResponse {
  urls: Record<string, SignedUrlInfo>;  // action_id -> SignedUrlInfo
  expires_in: number;
}

export interface ActionCreate {
  name: string;
  description: string;
  pictureUrl?: string | null;
  soundUrl?: string | null;
  defaults?: ActionDefaults | null;
}

export interface ActionUpdate {
  name?: string;
  description?: string;
  pictureUrl?: string | null;
  soundUrl?: string | null;
  defaults?: ActionDefaults | null;
}

export interface ActionListResponse {
  actions: Action[];
  count: number;
}

export interface FileUploadResponse {
  url: string;
  message: string;
}

export interface ActionFormData {
  name: string;
  description: string;
  pictureFile: File | null;
  soundFile: File | null;
  existingPictureUrl?: string | null;
  existingSoundUrl?: string | null;
}

// Validation constants
export const ACTION_VALIDATION = {
  NAME_MIN_LENGTH: 1,
  NAME_MAX_LENGTH: 100,
  DESCRIPTION_MIN_LENGTH: 1,
  DESCRIPTION_MAX_LENGTH: 500,
  PICTURE_MAX_SIZE: 10 * 1024 * 1024,  // 10MB
  SOUND_MAX_SIZE: 5 * 1024 * 1024,     // 5MB
  PICTURE_FORMATS: ['image/jpeg', 'image/png', 'image/gif'],
  SOUND_FORMATS: ['audio/mpeg', 'audio/wav', 'audio/aac', 'audio/x-m4a'],
  PICTURE_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.gif'],
  SOUND_EXTENSIONS: ['.mp3', '.wav', '.aac', '.m4a']
} as const;
